import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import { initAndApplyRestaurantCustoms, applyRestaurantCustoms  } from '@/utils/restaurant_customs';


//import vue3GoogleLogin from 'vue3-google-login'
//import gAuthPlugin from 'vue3-google-oauth2';
//import GoogleSignInPlugin from "vue3-google-signin"

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import 'fontsource-montserrat/700.css';

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css';

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    iconfont: 'mdi', // Utiliza el conjunto de íconos de Material Design
  },
})

import "jquery"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.js"
//import 'bootstrap-vue/dist/bootstrap-vue.css';
//import BootstrapVue from 'bootstrap-vue';
import "axios"

import 'bootstrap-icons/font/bootstrap-icons.css'; // Importa el archivo CSS de Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons';

import HighchartsVue from 'highcharts-vue';

const token = sessionStorage.getItem('token');
const partnerToken = sessionStorage.getItem('partner_token');

const app = createApp(App)
    .use(store)
    .use(router)
    .use(HighchartsVue)
    .use(vuetify)
    .use(ElementPlus, {
      compilerOptions: { isCustomElement: tag => tag.startsWith('el-') },
    })
    .use(HighchartsVue)


router.isReady().then(() => {
  const restaurant = router.currentRoute.value.params.restaurant
  const appInit = token && !partnerToken ? initAndApplyRestaurantCustoms(token, restaurant) : Promise.resolve(applyRestaurantCustoms());

  appInit.then(() => {
    
      app.mount('#app');
  });
});
